import React from 'react';
import { useAppStore } from '@/store/appStore';
import { useAuthStore } from '@/store/authStore';
import { LLMSettings } from '@/components/settings/LLMSettings';
import { UserManagement } from '@/components/settings/UserManagement';
import { UserProfile } from '@/components/settings/UserProfile';
import { RoleManagement } from '@/components/settings/RoleManagement';
import { TemplateSettingsComponent } from '@/components/settings/TemplateSettings';
import { ToolsRegistry } from '@/components/settings/ToolsRegistry';
import { DebugSettings } from '@/components/settings/DebugSettings';
import { IntegrationsSettings } from '@/components/settings/IntegrationsSettings';
import { GeneralSettings } from '@/components/settings/GeneralSettings';

export const SettingsModule: React.FC = () => {
  const { activeTab } = useAppStore();
  const { user: currentUser } = useAuthStore();

  const renderContent = () => {
    switch (activeTab) {
      case 'general':
        return <GeneralSettings />;
      case 'templates':
        return <TemplateSettingsComponent />;
      case 'llm':
        return <LLMSettings />;
      case 'tools':
        return <ToolsRegistry />;
      case 'integrations':
        return <IntegrationsSettings />;
      case 'users':
        // Show user management for admins/managers, profile for others
        if (currentUser?.role === 'admin' || currentUser?.role === 'manager') {
          return <UserManagement />;
        } else {
          return <UserProfile />;
        }
      case 'roles':
        return <RoleManagement />;
      case 'profile':
        return <UserProfile />;
      case 'debug':
        return <DebugSettings />;
      default:
        return (
          <div className="p-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Settings</h2>
            <p className="text-gray-600">Select a tab to configure settings.</p>
          </div>
        );
    }
  };

  return <div className="h-full bg-gray-50">{renderContent()}</div>;
};